import { Overlay, OverlayRef } from '@angular/cdk/overlay';
import { Component, OnInit, TemplateRef, ViewChild, ViewContainerRef } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Subscription } from 'rxjs';
import { Auth } from 'src/app/models/auth';
import { CentroCusto } from 'src/app/models/centro-custo';

import { AuthenticationService } from 'src/app/services/authentication.service';
import { CentroCustoService } from 'src/app/services/centro-custo.service';
import { StatusCadastro } from 'src/app/shared/enums/status-cadastro.enum';
import { NewAlertService } from 'src/app/shared/components/new-alert/new-alert.service';
import { FormControl } from '@angular/forms';
import { CardholderService } from 'src/app/services/cardholder.service';
import { Conductor } from 'src/app/models/conductors';

@Component({
    selector: 'app-centro-custo-list',
    templateUrl: './centro-custo-list.component.html'
})
export class CentroCustoListComponent implements OnInit {

    public centrosCustos: CentroCusto[];
    public centrosCustosList: CentroCusto[];
    private currentUser: Auth;
    public Status = StatusCadastro;

    //#region Filtro
    public filtroCodigo: string;
    public filtroNome: string;
    public filtroNomeResponsavel: string;
    public filtroEmailResponsavel: string;
    public filtroPesquisa: string;

    public codeCtrl: FormControl = new FormControl();
    public nameCtrl: FormControl = new FormControl();
    public nameManagerCtrl: FormControl = new FormControl();
    public emailManagerCtrl: FormControl = new FormControl();
    //#endregion

    //#region Ordenação
    sortOrder: boolean;
    //#endregion

    // menu de contexto
    overlayRef: OverlayRef | null;
    subscription: Subscription;
    @ViewChild('centroCustoMenu', { static: true }) contextMenu: TemplateRef<any>;

    // paginação
    currentPage = 1;
    showItem = '10';

    // modal delete
    public centroCustoToDelete: CentroCusto;
    public deleteCount: number;
    public selectAll: boolean;

    cardholderPage = 1;
    public cardholderList: Conductor[] = [];
    public totalItems: number = 0;

    constructor(
        private centroCustoService: CentroCustoService,
        private cardholderService: CardholderService,
        private authenticationService: AuthenticationService,
        private alertService: NewAlertService,
        private modalService: NgbModal,
        private router: Router,
        private route: ActivatedRoute,
        public overlay: Overlay,
        public viewContainerRef: ViewContainerRef) {
    }

    ngOnInit() {

        this.currentUser = this.authenticationService.currentUserValue;
        this.loadList();
    }

    loadList() {
        this.centroCustoService.getAll(this.currentUser.token.assignorGuid).subscribe(
            response => {
                this.centrosCustos = response.result;
                this.centrosCustosList = response.result;
            },
            error => {
                this.alertService.error('Ocorreu um erro ao consultar centros de custos. Por favor tente novamente mais tarde');
            }
        );
    }

    create() {
        this.router.navigate(['create'], { relativeTo: this.route.parent });
    }

    showFilter(content: any) {
        this.modalService.open(content, { centered: true, size: 'lg' });
    }

    realodList() {
        let tempList = this.centrosCustos;
        if (this.filtroCodigo) {
            tempList = tempList.filter(s => s.codigo.toLowerCase().includes(this.filtroCodigo.toLowerCase()));
        }

        if (this.filtroNome) {
            tempList = tempList.filter(s => s.nome.toLowerCase().includes(this.filtroNome.toLowerCase()));
        }

        if (this.filtroNomeResponsavel) {
            tempList = tempList.filter(s => s.nomeResponsavel.toLowerCase().includes(this.filtroNomeResponsavel.toLowerCase()));
        }

        if (this.filtroEmailResponsavel) {
            tempList = tempList.filter(s => s.emailResponsavel.toLowerCase().includes(this.filtroEmailResponsavel.toLowerCase()));
        }

        this.centrosCustosList = tempList;
    }

    orderBy(collumnName: string, sortOrder: boolean) {
        this.centrosCustosList.sort(
            (a, b) => {
                const dftl = sortOrder ? Number.MAX_VALUE : -Number.MAX_VALUE;
                const aVal = (a[collumnName] === null ? dftl : a[collumnName]).toString();
                const bVal = (b[collumnName] === null ? dftl : b[collumnName]).toString();
                let result = aVal.localeCompare(bVal, undefined, { numeric: true });
                if (sortOrder) {
                    result = bVal.localeCompare(aVal, undefined, { numeric: true });
                }
                return result;
            }
        );
    }

    applyFilter() {
        this.filtroCodigo = this.codeCtrl.value;
        this.filtroNome = this.nameCtrl.value;
        this.filtroNomeResponsavel = this.nameManagerCtrl.value;
        this.filtroEmailResponsavel = this.emailManagerCtrl.value;
        // this.realodList();
    }

    showDelete(content: any, centroCusto: CentroCusto) {
        this.centroCustoToDelete = centroCusto;
        this.modalService.open(content, { centered: true, size: 'lg' });
    }

    delete(centroCusto: CentroCusto) {
        this.centroCustoService.delete(centroCusto.centroCustoId, this.currentUser.token.assignorGuid, this.currentUser.token.userReferenceId).subscribe(
            response => {
                this.alertService.success('Centro de custo excluído com sucesso!');
                this.loadList();
                this.realodList();
            },
            error => {
                this.alertService.error('Ocorreu um erro ao excluir o centro de custo');
            }
        );
    }

    showCardholders(content: any, centroCusto: CentroCusto) {
        this.centroCustoToDelete = centroCusto;
        this.modalService.open(content, { centered: true, size: 'xl' });
        this.getCardholders(1);
    }

    getCardholders(event){
        this.cardholderPage = event;
        this.cardholderService.getCardholders(this.currentUser.token.assignorGuid, this.cardholderPage, 5, this.centroCustoToDelete.centroCustoId).subscribe(
            response => {
                this.cardholderList = response.result.items;
                this.totalItems = response.result.totalItems;
            },
            error => {
                this.alertService.error('Ocorreu um erro ao excluir o centro de custo');
            }
        );
    }

    updateDeleteCount() {
        this.deleteCount = this.centrosCustosList.filter(x => x.toDelete).length;
    }

    selectAllToDelete(value: boolean) {
        this.centrosCustosList.forEach(obj => {
            obj.toDelete = value;
        });
        this.updateDeleteCount();
    }

    showDeleteAll(content: any) {
        this.updateDeleteCount();
        this.modalService.open(content, { centered: true, size: 'lg' });
    }

    deleteAllSelected() {
        this.centrosCustosList.forEach(obj => {
            if (obj.toDelete) {
                this.delete(obj);
            }
        });
        this.updateDeleteCount();
    }

    edit(centroCusto: CentroCusto) {
        this.router.navigate([`edit/${centroCusto.centroCustoId}`], { relativeTo: this.route.parent });
    }
}
